import '../App.css';
import Hero from '../components/Hero';
import PictureBanner from '../assets/img/bg-nos-ac.jpg';
import { Helmet } from "react-helmet";

function AC() {

const hero = {
  banner: PictureBanner,
  title: 'Nos accès compassionnels (AC)',
  subtitle: 'Les accès compassionnels',
  noItems: 'Pas d\'AC en place actuellement avec PUT-SP',
  breadcrumb: [
    {
      title: 'Vraie-Vie',
      link: '/'
    },
    {
      title: 'Nos AC'
    }
  ]
}

 return (
  <>
    <Helmet>
      <title>Nos accès compassionnels | AbbVie Vraie Vie</title>
      <meta
        name="description"
        content="Portail ATU, RTU, Etudes"
      />
    </Helmet>
    <Hero 
        key={'hero-AC'}
        banner={hero.banner}
        title={hero.title}
        subtitle={hero.subtitle}
        noItems={hero.noItems}
        breadcrumb={hero.breadcrumb}
      />
      <p className='text-xxl'>
        L'Autorisation d'Accès Compassionnel (AAC) octroyée par l'ANSM à la demande d'un médecin est une procédure permettant l'utilisation, à titre exceptionnel, d'un médicament dans une indication précise en l'absence de demande d'autorisation de mise sur le marché (AMM) ou avant la délivrance d'une telle AMM pour ce médicament.
      </p>
      <div className='abbvie-container'>
        <div className="medium-container">
          <div className='flex2'>
            <h2>Pour ce faire, <strong>toutes les conditions</strong> suivantes doivent être remplies :</h2>
          </div>
          <div className='flex3'>
            <ul>
              <li>La maladie est grave, rare ou invalidante ;</li>
              <li>Il n'existe pas de traitement approprié ;</li>
              <li>L'efficacité et la sécurité de ce médicament, pour l'indication considérée, sont présumées favorables au regard des données cliniques disponibles (résultats des essais thérapeutiques) ;</li>
              <li>La mise en œuvre du traitement ne peut être différée ;</li>
              <li>Le médicament ne fait pas l'objet d'une recherche impliquant la personne humaine dans l'indication à des fins commerciales</li>
              <li>Et, lorsque le médicament fait l'objet d'une recherche impliquant la personne humaine dans l'indication, le laboratoire s'est engagé à demander une autorisation d'accès précoce auprès de la HAS et de l'ANSM.</li>
            </ul>
          </div>
        </div>
      </div>
      <p className='text-md'>
        AbbVie collabore étroitement avec l'ANSM pour le suivi des patients bénéficiant d'un ACCES COMPASSIONNEL selon les modalités fixées dans le Protocole d'Utilisation Thérapeutique et de Suivi des Patients (PUT-SP) le cas échéant. Le référentiel des accès compassionnels en cours est disponible sur le site de l'ANSM (https://ansm.sante.fr/documents/reference/referentiel-des-specialites-en-acces-derogatoire).
        Toute demande pour faire bénéficier un patient d'un ACCES COMPASSIONNEL en cours se fait via le site de l'ANSM « e-Saturne ».
        Ci-dessous, si applicable, le(s) ACCES COMPASSIONNEL(S) en cours concernant un médicament AbbVie dont le suivi des patients est fixé par un PUT-SP.
      </p>
  </>
 )
}

export default AC;
